import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3939fcfb")

_pushScopeId("data-v-3939fcfb")
const _hoisted_1 = {
  class: "gt-sm",
  style: {"width":"436px"}
}
const _hoisted_2 = { class: "marketContainer" }
const _hoisted_3 = { class: "firstFloor" }
const _hoisted_4 = { class: "title left" }
const _hoisted_5 = { style: {"margin-left":"17px"} }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { style: {"text-align":"end","color":"white","font-size":"15px"} }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = { style: {"text-align":"end","color":"white","font-size":"15px"} }
const _hoisted_12 = { class: "content" }
const _hoisted_13 = { class: "tabs" }
const _hoisted_14 = { class: "tabsContent" }
const _hoisted_15 = { class: "tabsContent" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "supplyInput" }
const _hoisted_18 = { style: {"flex-basis":"100%"} }
const _hoisted_19 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_20 = { class: "supplyDataContainer" }
const _hoisted_21 = { class: "firstContainer" }
const _hoisted_22 = { class: "first" }
const _hoisted_23 = { class: "second" }
const _hoisted_24 = { class: "third" }
const _hoisted_25 = { class: "fourth" }
const _hoisted_26 = { class: "last" }
const _hoisted_27 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_28 = { class: "sliderBody" }
const _hoisted_29 = { class: "sliderRunway" }
const _hoisted_30 = { class: "sliderMarks" }
const _hoisted_31 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_32 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_36 = {
  key: 0,
  style: {"display":"flex","justify-content":"space-between"}
}
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { class: "supplyInput" }
const _hoisted_39 = { style: {"flex-basis":"100%"} }
const _hoisted_40 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_41 = { class: "supplyDataContainer" }
const _hoisted_42 = { class: "firstContainer" }
const _hoisted_43 = { class: "first" }
const _hoisted_44 = { class: "second" }
const _hoisted_45 = { class: "third" }
const _hoisted_46 = { class: "fourth" }
const _hoisted_47 = { class: "last" }
const _hoisted_48 = { class: "sliderBody" }
const _hoisted_49 = { class: "sliderRunway" }
const _hoisted_50 = { class: "sliderMarks" }
const _hoisted_51 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_52 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { key: 1 }
const _hoisted_55 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_56 = { class: "button" }
const _hoisted_57 = {
  class: "lt-md",
  style: {"width":"400px","min-width":"280px","border-radius":"18px"}
}
const _hoisted_58 = { class: "appMarketContainer" }
const _hoisted_59 = { class: "appFirstFloor" }
const _hoisted_60 = { class: "appTitle left" }
const _hoisted_61 = { key: 0 }
const _hoisted_62 = { class: "appTitle" }
const _hoisted_63 = { class: "rightSecondFloor" }
const _hoisted_64 = { key: 1 }
const _hoisted_65 = { class: "appTitle" }
const _hoisted_66 = { class: "rightSecondFloor" }
const _hoisted_67 = { class: "appContent" }
const _hoisted_68 = { class: "appTabs" }
const _hoisted_69 = { class: "appTabsContent" }
const _hoisted_70 = { class: "appTabsContent" }
const _hoisted_71 = { key: 0 }
const _hoisted_72 = { class: "appSupplyInput" }
const _hoisted_73 = { style: {"flex-basis":"100%"} }
const _hoisted_74 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_75 = { class: "appSupplyDataContainer" }
const _hoisted_76 = { class: "appFirstContainer" }
const _hoisted_77 = { class: "appFirst" }
const _hoisted_78 = { class: "appSecond" }
const _hoisted_79 = { class: "appThird" }
const _hoisted_80 = { class: "appFourth" }
const _hoisted_81 = { class: "appLast" }
const _hoisted_82 = { class: "top" }
const _hoisted_83 = {
  class: "sliderBody",
  style: {"margin-left":"8px"}
}
const _hoisted_84 = { class: "sliderRunway" }
const _hoisted_85 = {
  class: "sliderMarks",
  style: {"width":"82%"}
}
const _hoisted_86 = { class: "bottom" }
const _hoisted_87 = { class: "bottom" }
const _hoisted_88 = { key: 0 }
const _hoisted_89 = { key: 1 }
const _hoisted_90 = { class: "bottom" }
const _hoisted_91 = {
  key: 0,
  class: "bottom"
}
const _hoisted_92 = { key: 1 }
const _hoisted_93 = { class: "appSupplyInput" }
const _hoisted_94 = { style: {"flex-basis":"100%"} }
const _hoisted_95 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_96 = { class: "appSupplyDataContainer" }
const _hoisted_97 = { class: "appFirstContainer" }
const _hoisted_98 = { class: "appFirst" }
const _hoisted_99 = { class: "appSecond" }
const _hoisted_100 = { class: "appThird" }
const _hoisted_101 = { class: "appFourth" }
const _hoisted_102 = { class: "appLast" }
const _hoisted_103 = { class: "top" }
const _hoisted_104 = {
  class: "sliderBody",
  style: {"margin-left":"8px"}
}
const _hoisted_105 = { class: "sliderRunway" }
const _hoisted_106 = {
  class: "sliderMarks",
  style: {"width":"82%"}
}
const _hoisted_107 = { class: "bottom" }
const _hoisted_108 = { class: "bottom" }
const _hoisted_109 = { key: 0 }
const _hoisted_110 = { key: 1 }
const _hoisted_111 = { class: "bottom" }
const _hoisted_112 = { class: "appButton" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_q_input = _resolveComponent("q-input")
  const _component_q_slider = _resolveComponent("q-slider")
  const _component_q_btn = _resolveComponent("q-btn")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", null, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", null, [
              _createVNode("div", _hoisted_4, [
                _createVNode("img", {
                  src: _ctx.reserveDetail.logoSource,
                  width: "66.3",
                  height: "66.3",
                  alt: ""
                }, null, 8, ["src"]),
                _createVNode("span", _hoisted_5, _toDisplayString(_ctx.reserveDetail.symbol), 1)
              ])
            ]),
            _createVNode("div", null, [
              _createVNode("div", null, [
                (_ctx.isSupply === true)
                  ? (_openBlock(), _createBlock("div", _hoisted_6, [
                      _createVNode("div", _hoisted_7, _toDisplayString(_ctx.formatBigNumberStr(_ctx.reserveDetail.walletBalanceInTokenUnit,2)) + " " + _toDisplayString(_ctx.reserveDetail.symbol), 1),
                      _createVNode("div", _hoisted_8, _toDisplayString(_ctx.t("supplyDialog.walletBalance")), 1)
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_9, [
                      _createVNode("div", _hoisted_10, _toDisplayString(_ctx.formatBigNumberStr(_ctx.reserveDetail.totalAvailableAmount,2)) + " " + _toDisplayString(_ctx.reserveDetail.symbol), 1),
                      _createVNode("div", _hoisted_11, _toDisplayString(_ctx.t("supplyDialog.liquidity")), 1)
                    ]))
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_12, [
        _createVNode("div", _hoisted_13, [
          _createVNode("div", _hoisted_14, [
            _createVNode("div", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeTabs(true))),
              class: _ctx.isSupply?'active':'inactive'
            }, _toDisplayString(_ctx.t("supplyDialog.supply")), 3)
          ]),
          _createVNode("div", _hoisted_15, [
            _createVNode("div", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeTabs(false))),
              class: _ctx.isSupply?'inactive':'active'
            }, _toDisplayString(_ctx.t("supplyDialog.withDraw")), 3)
          ])
        ]),
        (_ctx.isSupply)
          ? (_openBlock(), _createBlock("div", _hoisted_16, [
              _createVNode("div", _hoisted_17, [
                _createVNode("div", _hoisted_18, [
                  _createVNode("div", _hoisted_19, [
                    _createVNode(_component_q_input, {
                      borderless: "",
                      "onUpdate:modelValue": _ctx.supplyAmountInput,
                      "model-value": _ctx.supplyAmount,
                      placeholder: 'Wallet   '+_ctx.formatBigNumberStr(_ctx.reserveDetail.walletBalanceInTokenUnit,2)+' '+_ctx.reserveDetail.symbol,
                      style: {"width":"80%","padding":"0 26px","font-size":"20px"}
                    }, null, 8, ["onUpdate:modelValue", "model-value", "placeholder"]),
                    (_ctx.showMaxSupply)
                      ? (_openBlock(), _createBlock("div", {
                          key: 0,
                          class: "max",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.maxSupplyInput && _ctx.maxSupplyInput(...args)))
                        }, _toDisplayString(_ctx.t("supplyDialog.max")), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_20, [
                _createVNode("div", _hoisted_21, [
                  _createVNode("div", _hoisted_22, [
                    _createVNode("p", null, _toDisplayString(_ctx.t("supplyDialog.supplyApy")), 1),
                    _createVNode("p", null, _toDisplayString(_ctx.t("supplyDialog.supplyBalance")), 1)
                  ]),
                  _createVNode("div", _hoisted_23, [
                    _createVNode("p", null, _toDisplayString(_ctx.formatBigNumberStr(_ctx.reserveDetail.supplyApy.times(100).plus( _ctx.reserveDetail.supplyDistributionApy.times(100)),2)) + "%", 1),
                    _createVNode("p", null, "$" + _toDisplayString(_ctx.formatBigNumberStr(_ctx.reserveDetail.supplyBalance,2)), 1)
                  ]),
                  _createVNode("div", _hoisted_24, [
                    _createVNode("p", null, _toDisplayString(_ctx.t("supplyDialog.interestRate")), 1),
                    _createVNode("p", null, _toDisplayString(_ctx.formatBigNumberStr(_ctx.reserveDetail.supplyApy.times(100),2)) + "% ", 1)
                  ]),
                  _createVNode("div", _hoisted_25, [
                    _createVNode("p", null, _toDisplayString(_ctx.t("supplyDialog.miningAPY")), 1),
                    _createVNode("p", null, _toDisplayString(_ctx.formatBigNumberStr(_ctx.reserveDetail.supplyDistributionApy.times(100),2)) + "%", 1)
                  ])
                ]),
                _createVNode("div", _hoisted_26, [
                  _createVNode("div", null, _toDisplayString(_ctx.t("supplyDialog.supplyRate")), 1),
                  _hoisted_27,
                  _createVNode("div", _hoisted_28, [
                    _createVNode("div", _hoisted_29, [
                      _createVNode(_component_q_slider, {
                        modelValue: _ctx.sliderSupplyPercent,
                        "onUpdate:modelValue": [
                          _cache[4] || (_cache[4] = ($event: any) => (_ctx.sliderSupplyPercent = $event)),
                          _cache[5] || (_cache[5] = ($event: any) => (_ctx.sliderSupplyPercentChange($event)))
                        ],
                        style: {"height":"6px","position":"absolute","z-index":"2"},
                        disable: _ctx.selectedReserveDetail.symbol==='mSOL'&&_ctx.selectedReserveDetail.totalLiquidityInUsd.isGreaterThan(100000000),
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sliderClick())),
                        onMousedown: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sliderClick())),
                        min: 0,
                        max: 100
                      }, null, 8, ["modelValue", "disable"]),
                      _createVNode("div", _hoisted_30, [
                        _createVNode("div", {
                          class: ["sliderMarksText", _ctx.sliderSupplyPercent>0?'markActive':''],
                          style: {"left":"0"}
                        }, null, 2),
                        _createVNode("div", {
                          class: ["sliderMarksText", _ctx.sliderSupplyPercent>20?'markActive':''],
                          style: {"left":"20%"}
                        }, null, 2),
                        _createVNode("div", {
                          class: ["sliderMarksText", _ctx.sliderSupplyPercent>40?'markActive':''],
                          style: {"left":"40%"}
                        }, null, 2),
                        _createVNode("div", {
                          class: ["sliderMarksText", _ctx.sliderSupplyPercent>60?'markActive':''],
                          style: {"left":"60%"}
                        }, null, 2),
                        _createVNode("div", {
                          class: ["sliderMarksText", _ctx.sliderSupplyPercent>80?'markActive':''],
                          style: {"left":"80%"}
                        }, null, 2),
                        _createVNode("div", {
                          class: ["sliderMarksText", _ctx.sliderSupplyPercent===100?'markActive':''],
                          style: {"left":"100%"}
                        }, null, 2)
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_31, [
                    _createVNode("div", null, _toDisplayString(_ctx.t("supplyDialog.collateralFactor")), 1),
                    _createVNode("p", null, _toDisplayString(_ctx.reserveDetail.collateralFactor.toFixed(2)), 1)
                  ]),
                  _createVNode("div", _hoisted_32, [
                    _createVNode("div", null, _toDisplayString(_ctx.t("supplyDialog.borrowLimit")), 1),
                    (isNaN(Number(_ctx.supplyAmount))||Number(_ctx.supplyAmount)<0)
                      ? (_openBlock(), _createBlock("p", _hoisted_33, "$" + _toDisplayString(_ctx.formatBigNumberStr(_ctx.userBorrowLimit,2)), 1))
                      : (_openBlock(), _createBlock("p", _hoisted_34, "$" + _toDisplayString(_ctx.formatBigNumberStr(_ctx.calcNewBorrowLimit(_ctx.supplyAmount, false),2)), 1))
                  ]),
                  _createVNode("div", _hoisted_35, [
                    _createVNode("div", null, _toDisplayString(_ctx.t("supplyDialog.borrowLimitUsedPercent")), 1),
                    _createVNode("p", null, _toDisplayString(_ctx.calcNewBorrowLimitUsedPercent(_ctx.supplyAmount,0, false)?.toFixed(2)) + "%", 1)
                  ]),
                  (_ctx.reserveDetail.symbol==='mSOL')
                    ? (_openBlock(), _createBlock("div", _hoisted_36, [
                        _createVNode("div", null, _toDisplayString(_ctx.t("supplyDialog.supplyMaxLimit100M")), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_37, [
              _createVNode("div", _hoisted_38, [
                _createVNode("div", _hoisted_39, [
                  _createVNode("div", _hoisted_40, [
                    _createVNode(_component_q_input, {
                      style: {"width":"80%","padding":"0 26px","font-size":"20px"},
                      borderless: "",
                      modelValue: _ctx.withdrawAmount,
                      "onUpdate:modelValue": [
                        _cache[8] || (_cache[8] = ($event: any) => (_ctx.withdrawAmount = $event)),
                        _ctx.withdrawInput
                      ],
                      placeholder: 'Liquidity   '+_ctx.formatBigNumberStr(_ctx.reserveDetail.totalAvailableAmount,2)+' '+_ctx.reserveDetail.symbol
                    }, null, 8, ["modelValue", "placeholder", "onUpdate:modelValue"]),
                    (_ctx.showMaxWithdraw)
                      ? (_openBlock(), _createBlock("div", {
                          key: 0,
                          class: "max",
                          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.maxWithDrawInput && _ctx.maxWithDrawInput(...args)))
                        }, _toDisplayString(_ctx.t("supplyDialog.max")), 1))
                      : (_ctx.userBorrowLimitUsedPercent&&Number(_ctx.userBorrowLimitUsedPercent)<85)
                        ? (_openBlock(), _createBlock("div", {
                            key: 1,
                            class: "max",
                            style: {"white-space":"nowrap"},
                            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.set85LimitWithdrawAmount && _ctx.set85LimitWithdrawAmount(...args)))
                          }, _toDisplayString(_ctx.t("supplyDialog.limit85")), 1))
                        : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_41, [
                _createVNode("div", _hoisted_42, [
                  _createVNode("div", _hoisted_43, [
                    _createVNode("p", null, _toDisplayString(_ctx.t("supplyDialog.supplyApy")), 1),
                    _createVNode("p", null, _toDisplayString(_ctx.t("supplyDialog.supplyBalance")), 1)
                  ]),
                  _createVNode("div", _hoisted_44, [
                    _createVNode("p", null, _toDisplayString(_ctx.formatBigNumberStr(_ctx.reserveDetail.supplyApy.times(100).plus( _ctx.reserveDetail.supplyDistributionApy.times(100)),2)) + "%", 1),
                    _createVNode("p", null, "$" + _toDisplayString(_ctx.formatBigNumberStr(_ctx.reserveDetail.supplyBalance,2)), 1)
                  ]),
                  _createVNode("div", _hoisted_45, [
                    _createVNode("p", null, _toDisplayString(_ctx.t("supplyDialog.interestRate")), 1),
                    _createVNode("p", null, _toDisplayString(_ctx.formatBigNumberStr(_ctx.reserveDetail.supplyApy.times(100),2)) + "% ", 1)
                  ]),
                  _createVNode("div", _hoisted_46, [
                    _createVNode("p", null, _toDisplayString(_ctx.t("supplyDialog.miningAPY")), 1),
                    _createVNode("p", null, _toDisplayString(_ctx.formatBigNumberStr(_ctx.reserveDetail.supplyDistributionApy.times(100),2)) + "%", 1)
                  ])
                ]),
                _createVNode("div", _hoisted_47, [
                  _createVNode("div", null, _toDisplayString(_ctx.t("supplyDialog.withdrawRate")), 1),
                  _createVNode("div", _hoisted_48, [
                    _createVNode("div", _hoisted_49, [
                      _createVNode(_component_q_slider, {
                        modelValue: _ctx.sliderWithdrawPercent,
                        "onUpdate:modelValue": [
                          _cache[11] || (_cache[11] = ($event: any) => (_ctx.sliderWithdrawPercent = $event)),
                          _cache[12] || (_cache[12] = ($event: any) => (_ctx.sliderWithdrawPercentChange($event)))
                        ],
                        style: {"height":"6px","position":"absolute","z-index":"2"},
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.sliderClick())),
                        onMousedown: _cache[14] || (_cache[14] = ($event: any) => (_ctx.sliderClick())),
                        disable: _ctx.userBorrowLimitUsedPercent>=85&&(_ctx.reserveDetail.isEnterMarket),
                        min: 0,
                        max: 100
                      }, null, 8, ["modelValue", "disable"]),
                      _createVNode("div", _hoisted_50, [
                        _createVNode("div", {
                          class: ["sliderMarksText", _ctx.sliderWithdrawPercent>0?'markActive':''],
                          style: {"left":"0"}
                        }, null, 2),
                        _createVNode("div", {
                          class: ["sliderMarksText", _ctx.sliderWithdrawPercent>20?'markActive':''],
                          style: {"left":"20%"}
                        }, null, 2),
                        _createVNode("div", {
                          class: ["sliderMarksText", _ctx.sliderWithdrawPercent>40?'markActive':''],
                          style: {"left":"40%"}
                        }, null, 2),
                        _createVNode("div", {
                          class: ["sliderMarksText", _ctx.sliderWithdrawPercent>60?'markActive':''],
                          style: {"left":"60%"}
                        }, null, 2),
                        _createVNode("div", {
                          class: ["sliderMarksText", _ctx.sliderWithdrawPercent>80?'markActive':''],
                          style: {"left":"80%"}
                        }, null, 2),
                        _createVNode("div", {
                          class: ["sliderMarksText", _ctx.sliderWithdrawPercent===100?'markActive':''],
                          style: {"left":"100%"}
                        }, null, 2)
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_51, [
                    _createVNode("div", null, _toDisplayString(_ctx.t("supplyDialog.collateralFactor")), 1),
                    _createVNode("p", null, _toDisplayString(_ctx.reserveDetail.collateralFactor.toFixed(2)), 1)
                  ]),
                  _createVNode("div", _hoisted_52, [
                    _createVNode("div", null, _toDisplayString(_ctx.t("supplyDialog.borrowLimit")), 1),
                    (isNaN(Number(_ctx.withdrawAmount))||Number(_ctx.withdrawAmount)<0)
                      ? (_openBlock(), _createBlock("p", _hoisted_53, "$" + _toDisplayString(_ctx.formatBigNumberStr(_ctx.userBorrowLimit,2)), 1))
                      : (_openBlock(), _createBlock("p", _hoisted_54, "$" + _toDisplayString(_ctx.formatBigNumberStr(_ctx.calcNewBorrowLimit(-_ctx.withdrawAmount, false),2)), 1))
                  ]),
                  _createVNode("div", _hoisted_55, [
                    _createVNode("div", null, _toDisplayString(_ctx.t("supplyDialog.borrowLimitUsedPercent")), 1),
                    _createVNode("p", null, _toDisplayString(_ctx.calcNewBorrowLimitUsedPercent(-_ctx.withdrawAmount,0, false).toFixed(2)) + "%", 1)
                  ])
                ])
              ])
            ])),
        _createVNode("div", null, [
          _createVNode("div", _hoisted_56, [
            _createVNode(_component_q_btn, {
              "no-caps": "",
              class: "cancel",
              onClick: _ctx.cancel
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.t('supplyDialog.cancel')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            (_ctx.isSupply)
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 0,
                  "no-caps": "",
                  class: "supply",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('onSupply', _ctx.supplyAmount))),
                  disabled: !_ctx.supplyButtonEnable,
                  style: _ctx.supplyButtonEnable?'background: #2FCEFB;':' background: #999999;'
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.supplyButtonText), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "style"]))
              : (_openBlock(), _createBlock(_component_q_btn, {
                  key: 1,
                  "no-caps": "",
                  class: ["supply", 
                     {'warningBtn':((_ctx.withdrawAmount && !isNaN(_ctx.withdrawAmount) && _ctx.withdrawAmount>0)&&(_ctx.calcNewBorrowLimitUsedPercent(-_ctx.withdrawAmount,0,false).toFixed(2)>=95))&&_ctx.reserveDetail.isEnterMarket
                     }],
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.$emit('onWithdraw', _ctx.withdrawAmount))),
                  style: _ctx.withdrawButtonEnable?'background: #2FCEFB;':' background: #999999;',
                  disabled: !_ctx.withdrawButtonEnable
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.withdrawButtonText), 1)
                  ]),
                  _: 1
                }, 8, ["style", "class", "disabled"]))
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_57, [
      _createVNode("div", _hoisted_58, [
        _createVNode("div", null, [
          _createVNode("div", _hoisted_59, [
            _createVNode("div", null, [
              _createVNode("div", _hoisted_60, [
                _createVNode("img", {
                  src: _ctx.reserveDetail.logoSource,
                  height: "39",
                  width: "39",
                  alt: ""
                }, null, 8, ["src"]),
                _createVNode("span", null, _toDisplayString(_ctx.reserveDetail.symbol), 1)
              ])
            ]),
            _createVNode("div", null, [
              _createVNode("div", null, [
                (_ctx.isSupply === true)
                  ? (_openBlock(), _createBlock("div", _hoisted_61, [
                      _createVNode("div", _hoisted_62, _toDisplayString(_ctx.reserveDetail.walletBalanceInTokenUnit.toFixed(2)) + " " + _toDisplayString(_ctx.reserveDetail.symbol), 1),
                      _createVNode("div", _hoisted_63, _toDisplayString(_ctx.t("supplyDialog.walletBalance")), 1)
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_64, [
                      _createVNode("div", _hoisted_65, _toDisplayString(_ctx.reserveDetail.totalAvailableAmount.toFixed(2)) + " " + _toDisplayString(_ctx.reserveDetail.symbol), 1),
                      _createVNode("div", _hoisted_66, _toDisplayString(_ctx.t("supplyDialog.liquidity")), 1)
                    ]))
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_67, [
        _createVNode("div", _hoisted_68, [
          _createVNode("div", _hoisted_69, [
            _createVNode("div", {
              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.changeTabs(true))),
              class: _ctx.isSupply?'active':'inactive'
            }, _toDisplayString(_ctx.t("supplyDialog.supply")), 3)
          ]),
          _createVNode("div", _hoisted_70, [
            _createVNode("div", {
              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.changeTabs(false))),
              class: _ctx.isSupply?'inactive':'active'
            }, _toDisplayString(_ctx.t("supplyDialog.withDraw")), 3)
          ])
        ]),
        (_ctx.isSupply)
          ? (_openBlock(), _createBlock("div", _hoisted_71, [
              _createVNode("div", _hoisted_72, [
                _createVNode("div", _hoisted_73, [
                  _createVNode("div", _hoisted_74, [
                    _createVNode(_component_q_input, {
                      borderless: "",
                      placeholder: 'Wallet   '+_ctx.reserveDetail.walletBalanceInTokenUnit.toFixed(2)+' '+_ctx.reserveDetail.symbol,
                      "onUpdate:modelValue": _ctx.supplyAmountInput,
                      onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.supplyAmountChange($event))),
                      "model-value": _ctx.supplyAmount,
                      onBlur: _ctx.inputBlur,
                      style: {"width":"80%","padding-left":"15px"}
                    }, null, 8, ["placeholder", "onUpdate:modelValue", "model-value", "onBlur"]),
                    (_ctx.showMaxSupply)
                      ? (_openBlock(), _createBlock("div", {
                          key: 0,
                          class: "appMax",
                          onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.maxSupplyInput && _ctx.maxSupplyInput(...args)))
                        }, _toDisplayString(_ctx.t("supplyDialog.max")), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_75, [
                _createVNode("div", _hoisted_76, [
                  _createVNode("div", _hoisted_77, [
                    _createVNode("p", null, _toDisplayString(_ctx.t("supplyDialog.supplyApy")), 1),
                    _createVNode("p", null, _toDisplayString(_ctx.t("supplyDialog.supplyBalance")), 1)
                  ]),
                  _createVNode("div", _hoisted_78, [
                    _createVNode("p", null, _toDisplayString(_ctx.formatBigNumberStr(_ctx.reserveDetail.supplyApy.times(100).plus( _ctx.reserveDetail.supplyDistributionApy.times(100)),2)) + "%", 1),
                    _createVNode("p", null, "$" + _toDisplayString(_ctx.formatBigNumberStr(_ctx.reserveDetail.supplyBalance,2)), 1)
                  ]),
                  _createVNode("div", _hoisted_79, [
                    _createVNode("p", null, _toDisplayString(_ctx.t("supplyDialog.interestRate")), 1),
                    _createVNode("p", null, _toDisplayString(_ctx.formatBigNumberStr(_ctx.reserveDetail.supplyApy.times(100),2)) + "% ", 1)
                  ]),
                  _createVNode("div", _hoisted_80, [
                    _createVNode("p", null, _toDisplayString(_ctx.t("supplyDialog.miningAPY")), 1),
                    _createVNode("p", null, _toDisplayString(_ctx.formatBigNumberStr(_ctx.reserveDetail.supplyDistributionApy.times(100),2)) + "%", 1)
                  ])
                ]),
                _createVNode("div", _hoisted_81, [
                  _createVNode("div", _hoisted_82, _toDisplayString(_ctx.t("supplyDialog.supplyRate")), 1),
                  _createVNode("div", _hoisted_83, [
                    _createVNode("div", _hoisted_84, [
                      _createVNode(_component_q_slider, {
                        modelValue: _ctx.sliderSupplyPercent,
                        "onUpdate:modelValue": [
                          _cache[21] || (_cache[21] = ($event: any) => (_ctx.sliderSupplyPercent = $event)),
                          _cache[22] || (_cache[22] = ($event: any) => (_ctx.sliderSupplyPercentChange($event)))
                        ],
                        style: {"height":"5px","position":"absolute","z-index":"2","width":"96%"},
                        disable: _ctx.selectedReserveDetail.symbol==='mSOL'&&_ctx.selectedReserveDetail.totalLiquidityInUsd.isGreaterThan(100000000),
                        onMousedown: _ctx.sliderClick,
                        onClick: _ctx.sliderClick,
                        min: 0,
                        max: 100
                      }, null, 8, ["modelValue", "disable", "onMousedown", "onClick"]),
                      _createVNode("div", _hoisted_85, [
                        _createVNode("div", {
                          class: ["sliderMarksText", _ctx.sliderSupplyPercent>0?'markActive':''],
                          style: {"left":"0"}
                        }, null, 2),
                        _createVNode("div", {
                          class: ["sliderMarksText", _ctx.sliderSupplyPercent>20?'markActive':''],
                          style: {"left":"20%"}
                        }, null, 2),
                        _createVNode("div", {
                          class: ["sliderMarksText", _ctx.sliderSupplyPercent>40?'markActive':''],
                          style: {"left":"40%"}
                        }, null, 2),
                        _createVNode("div", {
                          class: ["sliderMarksText", _ctx.sliderSupplyPercent>60?'markActive':''],
                          style: {"left":"60%"}
                        }, null, 2),
                        _createVNode("div", {
                          class: ["sliderMarksText", _ctx.sliderSupplyPercent>80?'markActive':''],
                          style: {"left":"80%"}
                        }, null, 2),
                        _createVNode("div", {
                          class: ["sliderMarksText", _ctx.sliderSupplyPercent===100?'markActive':''],
                          style: {"left":"100%"}
                        }, null, 2)
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_86, [
                    _createVNode("div", null, _toDisplayString(_ctx.t("supplyDialog.collateralFactor")), 1),
                    _createVNode("p", null, _toDisplayString(_ctx.reserveDetail.collateralFactor.toFixed(2)), 1)
                  ]),
                  _createVNode("div", _hoisted_87, [
                    _createVNode("div", null, _toDisplayString(_ctx.t("supplyDialog.borrowLimit")), 1),
                    (isNaN(Number(_ctx.supplyAmount))||Number(_ctx.supplyAmount)<0)
                      ? (_openBlock(), _createBlock("p", _hoisted_88, "$" + _toDisplayString(_ctx.formatBigNumberStr(_ctx.userBorrowLimit,2)), 1))
                      : (_openBlock(), _createBlock("p", _hoisted_89, "$" + _toDisplayString(_ctx.formatBigNumberStr(_ctx.calcNewBorrowLimit(_ctx.supplyAmount, false),2)), 1))
                  ]),
                  _createVNode("div", _hoisted_90, [
                    _createVNode("div", null, _toDisplayString(_ctx.t("supplyDialog.borrowLimitUsedPercent")), 1),
                    _createVNode("p", null, _toDisplayString(_ctx.calcNewBorrowLimitUsedPercent(_ctx.supplyAmount,0, false).toFixed(2)) + "%", 1)
                  ]),
                  (_ctx.reserveDetail.symbol==='mSOL')
                    ? (_openBlock(), _createBlock("div", _hoisted_91, [
                        _createVNode("div", null, _toDisplayString(_ctx.t("supplyDialog.supplyMaxLimit100M")), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_92, [
              _createVNode("div", _hoisted_93, [
                _createVNode("div", _hoisted_94, [
                  _createVNode("div", _hoisted_95, [
                    _createVNode(_component_q_input, {
                      style: {"width":"80%","padding-left":"15px"},
                      borderless: "",
                      placeholder: 'Liquidity   '+_ctx.reserveDetail.totalAvailableAmount.toFixed(2)+' '+_ctx.reserveDetail.symbol,
                      modelValue: _ctx.withdrawAmount,
                      "onUpdate:modelValue": [
                        _cache[23] || (_cache[23] = ($event: any) => (_ctx.withdrawAmount = $event)),
                        _ctx.withdrawInput
                      ],
                      onBlur: _ctx.inputBlur,
                      onChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.withdrawAmountChange($event)))
                    }, null, 8, ["placeholder", "modelValue", "onBlur", "onUpdate:modelValue"]),
                    (_ctx.showMaxWithdraw)
                      ? (_openBlock(), _createBlock("div", {
                          key: 0,
                          class: "appMax",
                          onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.maxWithDrawInput && _ctx.maxWithDrawInput(...args)))
                        }, _toDisplayString(_ctx.t("supplyDialog.max")), 1))
                      : (_ctx.userBorrowLimitUsedPercent&&Number(_ctx.userBorrowLimitUsedPercent)<85)
                        ? (_openBlock(), _createBlock("div", {
                            key: 1,
                            class: "appMax",
                            style: {"white-space":"nowrap"},
                            onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.set85LimitWithdrawAmount && _ctx.set85LimitWithdrawAmount(...args)))
                          }, _toDisplayString(_ctx.t("supplyDialog.limit85")), 1))
                        : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_96, [
                _createVNode("div", _hoisted_97, [
                  _createVNode("div", _hoisted_98, [
                    _createVNode("p", null, _toDisplayString(_ctx.t("supplyDialog.supplyApy")), 1),
                    _createVNode("p", null, _toDisplayString(_ctx.t("supplyDialog.supplyBalance")), 1)
                  ]),
                  _createVNode("div", _hoisted_99, [
                    _createVNode("p", null, _toDisplayString(_ctx.formatBigNumberStr(_ctx.reserveDetail.supplyApy.times(100).plus( _ctx.reserveDetail.supplyDistributionApy.times(100)),2)) + "%", 1),
                    _createVNode("p", null, "$" + _toDisplayString(_ctx.formatBigNumberStr(_ctx.reserveDetail.supplyBalance,2)), 1)
                  ]),
                  _createVNode("div", _hoisted_100, [
                    _createVNode("p", null, _toDisplayString(_ctx.t("supplyDialog.interestRate")), 1),
                    _createVNode("p", null, _toDisplayString(_ctx.formatBigNumberStr(_ctx.reserveDetail.supplyApy.times(100),2)) + "% ", 1)
                  ]),
                  _createVNode("div", _hoisted_101, [
                    _createVNode("p", null, _toDisplayString(_ctx.t("supplyDialog.miningAPY")), 1),
                    _createVNode("p", null, _toDisplayString(_ctx.formatBigNumberStr(_ctx.reserveDetail.supplyDistributionApy.times(100),2)) + "%", 1)
                  ])
                ]),
                _createVNode("div", _hoisted_102, [
                  _createVNode("div", _hoisted_103, _toDisplayString(_ctx.t("supplyDialog.withdrawRate")), 1),
                  _createVNode("div", _hoisted_104, [
                    _createVNode("div", _hoisted_105, [
                      _createVNode(_component_q_slider, {
                        modelValue: _ctx.sliderWithdrawPercent,
                        "onUpdate:modelValue": [
                          _cache[27] || (_cache[27] = ($event: any) => (_ctx.sliderWithdrawPercent = $event)),
                          _cache[28] || (_cache[28] = ($event: any) => (_ctx.sliderWithdrawPercentChange($event)))
                        ],
                        style: {"height":"5px","position":"absolute","z-index":"2","width":"96%"},
                        onMousedown: _ctx.sliderClick,
                        disable: _ctx.userBorrowLimitUsedPercent>=85&&(_ctx.reserveDetail.isEnterMarket),
                        onClick: _ctx.sliderClick,
                        min: 0,
                        max: 100
                      }, null, 8, ["modelValue", "onMousedown", "disable", "onClick"]),
                      _createVNode("div", _hoisted_106, [
                        _createVNode("div", {
                          class: ["sliderMarksText", _ctx.sliderWithdrawPercent>0?'markActive':''],
                          style: {"left":"0"}
                        }, null, 2),
                        _createVNode("div", {
                          class: ["sliderMarksText", _ctx.sliderWithdrawPercent>20?'markActive':''],
                          style: {"left":"20%"}
                        }, null, 2),
                        _createVNode("div", {
                          class: ["sliderMarksText", _ctx.sliderWithdrawPercent>40?'markActive':''],
                          style: {"left":"40%"}
                        }, null, 2),
                        _createVNode("div", {
                          class: ["sliderMarksText", _ctx.sliderWithdrawPercent>60?'markActive':''],
                          style: {"left":"60%"}
                        }, null, 2),
                        _createVNode("div", {
                          class: ["sliderMarksText", _ctx.sliderWithdrawPercent>80?'markActive':''],
                          style: {"left":"80%"}
                        }, null, 2),
                        _createVNode("div", {
                          class: ["sliderMarksText", _ctx.sliderWithdrawPercent===100?'markActive':''],
                          style: {"left":"100%"}
                        }, null, 2)
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_107, [
                    _createVNode("div", null, _toDisplayString(_ctx.t("supplyDialog.collateralFactor")), 1),
                    _createVNode("p", null, _toDisplayString(_ctx.reserveDetail.collateralFactor.toFixed(2)), 1)
                  ]),
                  _createVNode("div", _hoisted_108, [
                    _createVNode("div", null, _toDisplayString(_ctx.t("supplyDialog.borrowLimit")), 1),
                    (isNaN(Number(_ctx.withdrawAmount))||Number(_ctx.withdrawAmount)<0)
                      ? (_openBlock(), _createBlock("p", _hoisted_109, "$" + _toDisplayString(_ctx.formatBigNumberStr(_ctx.userBorrowLimit,2)), 1))
                      : (_openBlock(), _createBlock("p", _hoisted_110, "$" + _toDisplayString(_ctx.formatBigNumberStr(_ctx.calcNewBorrowLimit(-_ctx.withdrawAmount, false),2)), 1))
                  ]),
                  _createVNode("div", _hoisted_111, [
                    _createVNode("div", null, _toDisplayString(_ctx.t("supplyDialog.borrowLimitUsedPercent")), 1),
                    _createVNode("p", null, _toDisplayString(_ctx.calcNewBorrowLimitUsedPercent(-_ctx.withdrawAmount,0, false).toFixed(2)) + "%", 1)
                  ])
                ])
              ])
            ])),
        _createVNode("div", null, [
          _createVNode("div", _hoisted_112, [
            _createVNode(_component_q_btn, {
              "no-caps": "",
              class: "appCancel",
              onClick: _ctx.cancel
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.t('supplyDialog.cancel')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            (_ctx.isSupply)
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 0,
                  "no-caps": "",
                  class: ["appSupply", {'fontReduction':_ctx.fontReduction('supply')}],
                  onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.$emit('onSupply', _ctx.supplyAmount))),
                  disabled: !_ctx.supplyButtonEnable,
                  style: _ctx.supplyButtonEnable?'background: #2FCEFB;':' background: #999999;'
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.supplyButtonText), 1)
                  ]),
                  _: 1
                }, 8, ["class", "disabled", "style"]))
              : (_openBlock(), _createBlock(_component_q_btn, {
                  key: 1,
                  "no-caps": "",
                  class: ["appSupply", 
                     {'warningBtn':((_ctx.withdrawAmount && !isNaN(_ctx.withdrawAmount) && _ctx.withdrawAmount>0)&&(_ctx.calcNewBorrowLimitUsedPercent(-_ctx.withdrawAmount,0,false).toFixed(2)>=95))&&_ctx.reserveDetail.isEnterMarket
                     ,'fontReduction':_ctx.fontReduction('withdraw')}],
                  onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.$emit('onWithdraw', _ctx.withdrawAmount))),
                  style: _ctx.withdrawButtonEnable?'background: #2FCEFB;':' background: #999999;',
                  disabled: !_ctx.withdrawButtonEnable
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.withdrawButtonText), 1)
                  ]),
                  _: 1
                }, 8, ["style", "class", "disabled"]))
          ])
        ])
      ])
    ])
  ], 64))
})